import { CollaboratorListResponse, FilterOptions } from './collaborator-service-types'

/**
 * Format collaborator list response from OLD backoffice API
 * OLD: {results: [], pages: 10}
 */
export const formatCollaboratorList = (
  response: CollaboratorListResponse
): CollaboratorListResponse => ({
  results: response.results || [],
  pages: response.pages || 1
})

/**
 * Format filter options from OLD backoffice API
 * GET /api/management/options
 */
export const formatFilterOptions = (response: FilterOptions | undefined | null): FilterOptions => ({
  companies: response?.companies || [],
  departments: response?.departments || [],
  jobs: response?.jobs || [],
  accountTypes: response?.accountTypes || [],
  typegroup: response?.typegroup || []
})

/**
 * Build comma+space separated string for OLD API
 * Example: [1, 2, 3] => "1, 2, 3"
 */
export const buildCommaSeparatedString = (items: Array<{ value: number | string }>): string =>
  items?.map(item => item.value).join(', ') || ''
